import React from 'react';
import { Container } from '../../../components';

const DesktopLayout = ({ aside, main }) => {
  return (
    <Container className="hidden lg:block desktop-layout">
      <div className="flex flex-wrap -mx-4 py-16">
        <aside className="w-3/12 px-4 hidden lg:block">
          {aside}
        </aside>
        <main className="w-full lg:w-9/12 px-4">
          {main}
        </main>
      </div>
    </Container>
  )
}

export default DesktopLayout
